/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import IOauthAuthzModel, { FORM_ID, FIELD_NAME } from './Model';
import ClientApp from '../../resource/oauthClientApp/View';
import Scopes from '../../resource/oauthScope/View';
import bind from '../../decorators/bind';
import App from '../../App';
import 'apmui/components/form/Controller';
import { RESOURCE } from 'apmui/resource/ResourceType';
import Object from 'apmui/util/Object';

const app = App.get();

export default class OauthAuthzView extends React.Component<IOauthAuthzModel> {
    @bind
    allowClick() {
        app.updateFormField(FORM_ID, FIELD_NAME, '1');
        app.submitForm(FORM_ID);
    }

    @bind
    denyClick() {
        app.updateFormField(FORM_ID, FIELD_NAME, '0');
        app.submitForm(FORM_ID);
    }

    render() {
        const pagetype = this.props[this.props.pageType];
        const strings = pagetype.strings;
        const resources = pagetype.resources;

        let error = pagetype.error;
        let firstClientApp;
        if (!error) {
            firstClientApp =
                resources &&
                resources[RESOURCE.OAUTH_CLIENT_APP] &&
                Object.values(resources[RESOURCE.OAUTH_CLIENT_APP]!)[0];
            if (!firstClientApp) {
                error = strings.loadingFailedError;
            }
        }

        let contents;
        if (!firstClientApp) {
            // error-only page
            contents = <div className="apmui-page-oauth-authz--error">{error}</div>;
        } else if (resources) {
            // normal authorization request
            const scopeRes = resources[RESOURCE.OAUTH_SCOPE];
            let scopes;
            if (scopeRes && Object.keys(scopeRes).length > 0) {
                scopes = (
                    <div className="apmui-page-oauth-authz--scopes">
                        <p>
                            {firstClientApp.description} {strings.scopeMessage}
                        </p>
                        <Scopes scopes={scopeRes} />
                    </div>
                );
            }

            contents = (
                <div>
                    <ClientApp app={firstClientApp} />
                    {scopes}
                    {pagetype.warning && <p className="apmui-page-oauth-authz--warning">{pagetype.warning}</p>}
                    <button className="apmui-button" onClick={this.denyClick}>
                        {strings.denyCaption}
                    </button>
                    <button className="apmui-button apmui-button-submit" onClick={this.allowClick}>
                        {strings.allowCaption}
                    </button>
                </div>
            );
        }

        return (
            <div className="apmui-content">
                <h2>{strings.authorizeTitle}</h2>
                {contents}
            </div>
        );
    }
}
